export enum ContentLayout11Theme {
  BLUE = 'BLUE',
  OPAL = 'OPAL',
}
